import { render, staticRenderFns } from "./BidDialog.vue?vue&type=template&id=39b53e98&"
import script from "./BidDialog.vue?vue&type=script&lang=js&"
export * from "./BidDialog.vue?vue&type=script&lang=js&"
import style0 from "./BidDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports